__turbopack_context__.v({
  "banner": "PlasmicCapTopSection-module__4y8KVa__banner",
  "body": "PlasmicCapTopSection-module__4y8KVa__body",
  "body2": "PlasmicCapTopSection-module__4y8KVa__body2",
  "header": "PlasmicCapTopSection-module__4y8KVa__header",
  "sectionHeader": "PlasmicCapTopSection-module__4y8KVa__sectionHeader",
  "sectionHeader2": "PlasmicCapTopSection-module__4y8KVa__sectionHeader2",
  "subtitle": "PlasmicCapTopSection-module__4y8KVa__subtitle",
  "subtitle2": "PlasmicCapTopSection-module__4y8KVa__subtitle2",
  "title": "PlasmicCapTopSection-module__4y8KVa__title",
  "title2": "PlasmicCapTopSection-module__4y8KVa__title2",
  "top": "PlasmicCapTopSection-module__4y8KVa__top",
  "top2": "PlasmicCapTopSection-module__4y8KVa__top2",
  "top3": "PlasmicCapTopSection-module__4y8KVa__top3",
});
